import { Button, Typography } from '@rrexpress/core';

export function ModalFooterCancelSave(props: {
  onSave: () => void,
  onCancel: () => void,
}) {
  return (
    <div className="flex gap-x-4">
      <Button
        data-testid="modal-confirm-cancel"
        type="button"
        variant="text"
        onClick={props.onSave}
      >
        <Typography level={5} fontWeight="bold">
          Batal
        </Typography>
      </Button>
      <Button
        data-testid="modal-confirm-submit"
        type="submit"
        variant="primary"
        onClick={props.onCancel}
      >
        <Typography level={5} color="white" fontWeight="bold">
          Simpan
        </Typography>
      </Button>
    </div>
  );
}

export default ModalFooterCancelSave;
